import React from "react";
import "bootstrap/dist/css/bootstrap.min.css"; 
import "../styles/quickcallStyles.css";
import bouncingImage from "../assets/icons/phone-call.png";

const QuickCall = () => {

  const handleClick = () => {
    window.open("tel:+919599953923", "_blank");
  };
  return (
    <>
    
    <div
      className="position-fixed bottom-0 end-0 mb-5 me-3"
      style={{ zIndex: 1000 }}
    >
      {/* Toggle Button */}
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ cursor: "pointer" }}
      >
        <img
          src={bouncingImage}
          onClick={handleClick}
          alt="Chat Toggle"
          className="img-fluid call-icon"
        />
      </div>
    </div>
    </>
  );
};

export default QuickCall;
